<template>
  <v-row justify="center" v-if="recibo">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="600px" transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <v-toolbar-title>Datos de la Factura</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="py-2">
          <v-form ref="vform" v-model="formValid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    autofocus
                    v-model.trim="form.nombre_cliente"
                    outlined
                    :rules="[rules.required, rules.minimumOneLetter]"
                    label="Nombre de Cliente"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model.trim="form.nit_cliente"
                    :rules="[rules.required, rules.onlyNumbers, rules.minValue, rules.maxValue]"
                    outlined
                    hint="Permite solo numeros por orden de Contablidad Nacional"
                    label="Nit de Cliente"
                    counter="25"
                    persistent-hint
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <!-- <v-text-field type="hidden" readonly v-model.trim="form.nit_empresa" :rules="fieldRules" filled label="Nit de Empresa"> </v-text-field> -->
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" rounded @click="saveForm"> <v-icon class="mx-1">mdi-content-save</v-icon> Guardar </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || 'Campo Obligatorio',
        minValue: (str) => (!!str && str.length >= 5) || 'El Nit debe ser mas de 5 Caracteres',
        maxValue: (str) => (!!str && str.length <= 25) || 'El Nit No debe  ser mas de 25 Caracteres',
        onlyNumbers: (v) => /^([0-9]+)$/.test(v) || 'el Nit Solo puede ser Numeros',
        minimumOneLetter: (v) => /(?=.*[a-zA-Z])/.test(v) || 'Permite por lo menos una letra',
      },
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,

      dialog: false,
      menu: false,
      formValid: true,
      recibo: null,
      form: {
        nombre_cliente: null,
        nit_cliente: null,
        sucursal_id: null,
      },
    };
  },
  methods: {
    async showThisView(recibo = null) {
      this.dialog = true;
      this.recibo = recibo;
      this.form.sucursal_id = await this.getPrograma(this.recibo.inscripcion_id);
    },
    async getPrograma(inscripcion_id) {
      const url = `${this.api_rest}/api/esam/inscripcion/id/${inscripcion_id}`;
      let url2 = `${this.api_rest}/esam/programa/id/`;
      const suc = await xaxios
        .get(url)
        .then(({ data }) => xaxios.get(url2 + data.programa_id).then(({ data }) => (data.sucursal_id ? data.sucursal_id : null)))
        .catch(() => null);
      //window.console.log("programa sucursal:", suc);
      if(!suc){
        this.$root.$notify.show(`El programa no tiene sucursal.`, { color: 'red', x: 'right' });
      }
      return suc;
    },
    async saveForm() {
      if (this.$refs.vform.validate()) {
        if (await this.$root.$confirm.open('Emitir Factura', 'Estas seguro?', { color: 'red' })) {
          const url = `${this.api_rest}/api/pagos/recibo/factura`;
          const formData = {
            recibo_id: this.recibo.id,
            factura: {
              emisor_id: this.$store.state.DATA_USER.id,
              nit_cliente: this.form.nit_cliente,
              nombre_cliente: this.form.nombre_cliente,
              sucursal_id: this.form.sucursal_id,
            },
          };
          xaxios
            .post(url, formData)
            .then(({ data }) => {
              window.console.log(formData,'data:::::::',data);
              if (data.factura) {
                this.$emit('open', data.factura.id, this.recibo);
                this.closeDialog();
              }
            })
            .catch((error) => this.$root.$notify.show(`${error.response ? error.response.data.error : 'Ocurrio un Error'}`, { color: 'primary' }));
        }
      }
    },
    closeDialog() {
      this.dialog = false;
      this.recibo = null;
      this.form = { nombre_cliente: null, nit_cliente: null, sucursal_id: null };
    },
  },
};
</script>

<style>
</style>